// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"50568666","453":"548b376e","745":"778d84bb"}[chunkId] + ".chunk.js";
};